<template>
  <div class=''>

    <!-- 返回栏 -->
    <div class="ban_box bg_box">
      <p @click="gotopath()"><img src="../../assets/img/fanhui.png"  style="margin-right:10px;margin-bottom:2px" alt="">NFT gallery</p>
    </div>

    <div class="divder_box">
      <el-divider></el-divider>
    </div>

    <!-- 内容区 -->
    <div class="ban_box banner_box" v-loading="loadingbanner">
      <!-- 图片 -->
      <div class="first_flex">
        <div class="img_box" v-loading="loading" ref="barparent">
          <img v-if="imageURI && certificateDetail.operationName == 'World Economic Forum 2022'" :src="imageURI"  @load="changeloading(imageURI)" style="width:100%" alt="">
          <img v-if="imageURID && certificateDetail.operationName == 'Digital Life Design 2022'" :src="imageURID"  @load="changeloading(imageURID)" style="width:100%" alt="">
          <img v-if="imageURIO && certificateDetail.operationName == 'Carbon Neutrality'" :src="imageURIO"  @load="changeloading(imageURIO)" style="width:100%" alt="">
          <div class="position_box">
            <div class="margin_box">{{certificateDetail.nickName}}</div>
            <div >{{certificateDetail.description}}</div>
          </div>
        </div>

        <div style="padding-top:20px" v-show="windowWidth<=980">
          <div class="right_box">
            <div>
              <h3>{{ form.name }}</h3>
            </div>
          </div>
          <div class="right_box">
            <div style="display:flex">
              <div class="yuan"></div>
              <p>Owned by :</p>
              <span>{{ form.owner }}</span>
            </div>
          </div>
        </div>

        <div class="collpass_box">
          <el-collapse v-model="formdata.activeName" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/Description.png" style="width:23px;height:19px;margin-right:15px" alt="">
                Description
              </template>
              <div>
                <div class="felx_descrip">
                  <div class="text_a">Issued by :</div>
                  <div class="text_b">MVGX</div>
                </div>
                <div class="felx_descrip">
                  <div class="text_a">Owned by :</div>
                  <div class="text_b">{{certificateDetail.name}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        
      </div>
      <!-- 信息 -->
      <div class="two_flex">

        <div v-show="windowWidth>980">
          <div class="right_box">
            <div>
              <h3 v-if="certificateDetail.operationName !== 'Carbon Neutrality'">Carbon Neutral For {{ certificateDetail.operationName }}</h3>
              <h3 v-else>{{ certificateDetail.operationName }}</h3>
            </div>
            <div class="top_btn_box">
            </div>
          </div>
          <!-- <div class="right_box">
            <div style="display:flex">
              <div class="yuan"></div>
              <p>Owned by :</p>
              <span>{{ form.owner }}</span>
            </div>
          </div> -->
        </div>
        

        <div class="collpass_box bg_coll_box">
          <!-- <div class="title" v-if="certificateDetail.operationName !== 'Carbon Neutrality'">Price</div>
          <div class="title_flex" v-if="certificateDetail.operationName !== 'Carbon Neutrality'">
            <div class="title_flex_txt">US$</div>
            <div class="title_flex_mon">35.00</div>
          </div> -->
          <div class="title_flex bg_box">
            <img src="../../assets/img/tishi.png" alt="">
            <div>This NFT has been purchased on {{formatDate(certificateDetail.certificateDate)}}</div>
          </div>
        </div>

        <div class="collpass_box detail_box">
          <el-collapse v-model="formdata.Details" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/Details.png" style="width:22px;height:22px;margin-right:15px" alt="">
                Details
              </template>
              <!-- <div class="coll_flex">
                <p class="text_left">Contract Address:</p>
                <p class="text_right">xxxxxxxx</p>
              </div> -->
              <div class="coll_flex bg_color">
                <p class="text_left">Token ID:</p>
                <p class="text_right">{{certificateDetail.sn}}</p>
              </div>
              <div class="coll_flex">
                <p class="text_left">Transaction Id:</p>
                <p style="color:#2181E2"><a :underline="false" target="_blank" :href="certificateDetail.nftContractUrl">{{certificateDetail.nftTransactionHash}}</a></p>
                <!-- <p class="text_right">{{certificateDetail.sn}}</p> -->
              </div>
              <div class="coll_flex bg_color">
                <p class="text_left">Token Standard:</p>
                <p class="text_right">ERC - 721</p>
              </div>
                            <div class="coll_flex">
                <p class="text_left">Blockchain:</p>
                <p class="text_right">Ethereum</p>
              </div>
                     <div class="coll_flex">

                     </div>

                <div class="coll_flex">
                  <p class="text_left">Carbon Neutralization Transaction Id:</p>
                  <p style="color:#2181E2"><a :underline="false" target="_blank" :href="certificateDetail.contractUrl">{{certificateDetail.transactionHash}}</a></p>
                  <!-- <p class="text_right">{{certificateDetail.sn}}</p> -->
                </div>
                <div class="coll_flex bg_color">
                  <p class="text_left">Token Standard:</p>
                  <p class="text_right">ERC - 20</p>
                </div>
              <div class="coll_flex">
                <p class="text_left">Blockchain:</p>
                <p class="text_right">Ethereum</p>
              </div>


            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 底部 -->
      
    </div>
    <div class="btm_box" v-if="certificateDetail.operationName !== 'Carbon Neutrality'">
      <div class="btm_box_box">
        <div class="flex_box_btm">
          <img src="../../assets/img/dingzhi.png" alt="">
          <div>Personalized Message</div>
        </div>
        <div class="banner_btm_box">{{certificateDetail.description}}</div>
      </div>
    </div>
    <!-- <Footer :widthmun='windowWidth'/> -->
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Headers from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue';
import {mapState} from "vuex";
import authority from '@/api/authority'
import nft from '@/api/nftgallery.js'
import {formatDateTime,formatDay,formatDate} from "@/util/date";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Headers,Footer},
  data() {
    // 这里存放数据
    return {
      token:'',
      sn:this.$route.query.sn,
      certificateDetail:'',
      dialogFormVisible:false,
      buyNowbool:false,
      imageURI:require('../../assets/img/nftimg1.png'),
      imageURID:require('../../assets/img/digital.png'),
      imageURIO:require('../../assets/img/MVGX-CNC-2022.jpeg'),
      acceptbool:false,
      cancelbool:false,
      makeoffbool:false,
      dialogmakeVisible:false,
      dialogbuyNowVisible:false,
      dialogBidVisible:false,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      // form:{
      //   category:'',
      // },
      category:'',
      loading: true,
      loadingbanner:false,
      buynowform:{
        tradingAccount:'',
      },
      formdata: {
        activeName: '1',
        Details: '1',
        Sale: '1',
        Offers: '1'
      },
      buynow:{
        tokenId:'',
        buyerAccount:'',
        price:'',
        currency:'',
      },
      formdatas: {
        tokenId:'',
        price: '',
        currency: 'EUR',
        expirationDate: '',
        payAccount:'',
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000
        },
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      form: state => state.nft.item,
      categories: (state) => state.nft.categories,
      currencyList: function (state) {
        return state.nft.currencyList.filter((i) => !i.crypto);
      },
      btnList:state => state.nft.btnList,
      offerslist:state => state.nft.offerslist,
      accountList: (state) => state.nft.accountList
    })},
  filters: {
		ellipsis (value) {
      if (!value) return ''
      let len=value.length;
      if (value.length > 20) {
        return value.substring(0,6) + '......' +value.substring(len-6,len)
      }
      return value
		}
	},
  // 监控data中的数据变化
  watch: {
    btnList(newval,oldval){
      if(newval){
        this.loadingbanner = false
      }
    },
    windowWidth (val) {
        let that = this;
        this.windowWidth = val
      },
  },
  // 方法集合
  methods: {
    formatDateTime: formatDateTime,
    formatDay: formatDay,
    formatDate:formatDate,
    //获取详情
    getnftDetail(){
      nft.getTravelRecord(res => {
          console.log('res',res)
          this.certificateDetail = res
      },{sn:this.sn})
    },
    gotopath() {

      // 逻辑跳转路由，勿删！！！
        this.$router.push({path: '/nftgallery'})
      
    },
    columnStyle({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 2) {
        //字体颜色
        return "color:#2181E2;";
      }

      if (columnIndex == 1) {
      }
    },
    getdivWidth(){
      const parentClientWidth = this.$refs.barparent.clientWidth;
    },
    handledate(data){
      var startAt = new Date(data).getTime();
      if(startAt <= Date.now()) {
          this.formdatas.expirationDate = new Date(Date.now()+1000 * 60 * 60);
      }
    },
    changeloading(src){
      let img = new Image()
      img.src = src
      let self = this
      img.onload = (()=>{
        self.loading = false
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.sn = this.$router.query.sn
    this.getnftDetail()
    this.getdivWidth();
    window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            this.windowWidth = window.fullWidth; // 宽
        })()
    }
    // this.$nextTick(()=>{
    //   this.$store.dispatch("nft/getNFTasset", {tokenId:this.form.id});
    //   this.$store.dispatch("nft/changebutton", {id:this.form.id});
    // })
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:10%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.ban_box {
  // width: 900px;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 20px;
}

.bg_box {
  height: 60px;
  line-height: 60px;

  p {
    font-size: 14px;
    font-family: ArialMT;
    color: #161616;
    cursor: pointer;
  }
}

::v-deep .divder_box {
  .el-divider--horizontal {
    margin: 0;
  }

  .el-divider {
    background-color: #F3F5F8;
  }
}

.banner_box {
  padding: 20px 20px;
  display: flex;
  flex-direction: row;

  .first_flex {
    flex: 3 0 0%;
    max-width: 32%;
    width: 0;

    .img_box {
      padding: 22px 15px 30px 15px;
      border: 1px solid #E7EAED;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      position: relative;
      .position_box{
        position: absolute;
        text-align: center;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        .margin_box{
          font-weight: 600;
          margin-bottom: 5px;
        }
        div{
          width: 145px;
          max-width: 145px;
          font-size: 14px;
          font-family: Gotham-Book, Gotham;
          font-weight: normal;
          color: #303236;
          line-height: 15px !important;
        }
      }
    }
  }

  .two_flex {
    flex: 4 0 0%;
    margin-left: 20px;
  }

  
}
.btm_box{
  padding: 0 20px;
  margin: 0 auto;
  .btm_box_box{
    border-radius: 4px;
    border: 1px solid #E7EAED;
    margin: 0 auto;
    .flex_box_btm{
      display: flex;
      padding: 28px 15px;
      align-items: center;
      border-bottom: 1px solid #E7EAED;
      img{
        width: 22px;
        height: 22px;
      }
      div{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #161616;
        line-height: 22px;
        margin-left: 20px;
      }
    }
    .banner_btm_box{
      min-height: 150px;
      padding: 19px 40px;
      font-size: 14px;
      font-family: ArialMT;
      color: #161616;
      line-height: 32px;
    }
  }
    
}

::v-deep .bg_coll_box {
  border-radius: 4px;
  border: 1px solid #E7EAED;

  .title{
    font-size: 12px;
    font-family: ArialMT;
    color: #8A949C;
    line-height: 14px;
    margin-bottom: 5px;
  }
  .title_flex{
    display: flex;
    .title_flex_txt{
      font-size: 16px;
      font-family: ArialMT;
      color: #161616;
      line-height: 18px;
      transform: translateY(10px);
      margin-right: 5px;
    }
    .title_flex_mon{
      font-size: 30px;
      font-family: Arial-BoldMT, Arial;
      font-weight: normal;
      color: #161616;
      line-height: 34px;
    }
  }
  .bg_box{
    background: rgba(21, 136, 105, 0.04);
    border-radius: 4px;
    align-items: center;
    padding: 0 20px;

    img{
      width: 18px;
      height: 18px;
    }
    div{
      font-size: 14px;
      font-family: ArialMT;
      color: #158869;
      line-height: 16px;
      margin-left: 20px;
    }
  }
  .el-collapse-item__content {
    background: #F7FAFC;
  }
}

::v-deep .detail_box{
  .el-collapse-item__content {
    padding: 0 !important;
  }
  .bg_color{
    background: #F9F9FA;
  }
}

::v-deep .collpass_box {
  margin-top: 20px;
  border: 1px solid #E7EAED;
  .felx_descrip{
    display: flex;
    justify-content: space-between;
    margin-top: 13px;
    .text_a{
      font-size: 14px;
      font-family: ArialMT;
      color: #8A949C;
      line-height: 16px;
      min-width: 30%;
    }
    .text_b{
      font-size: 14px;
      font-family: ArialMT;
      color: #161616;
      line-height: 16px;
      text-align: right;
    }
  }
  .el-collapse-item__header {
    border-bottom: 1px solid #E7EAED;
    padding-left: 15px;
    padding-right: 5px;
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #161616;
    line-height: 16px;
  }

  .el-icon-arrow-right:before {
    content: url('../../assets/img/icon_right.png');
  }
  .right_btn_box{
    .el-icon-arrow-right:before {
      content: "\e6e0";
    }
  }

  .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg)
  }

  .el-collapse-item__content {
    padding: 23px 15px 23px 15px;
    font-size: 12px;
    font-family: ArialMT;
    color: #8A949C;
    line-height: 16px;
  }

  .coll_flex {
    display: flex;
    justify-content: space-between;
    padding:15px 28px;
    .text_left{
      text-align: left;
      font-size: 14px;
      font-family: ArialMT;
      color: #8A949C;
      line-height: 16px;
    }
    .text_right{
      text-align: right;
      font-size: 14px;
      font-family: ArialMT;
      color: #161616;
      line-height: 16px;
    }
  }

  .collmon_box {
    p {
      font-size: 14px;
      font-family: ArialMT;
      color: #8A949C;
      line-height: 16px;
    }

    h3 {
      font-size: 30px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 700;
      color: #161616;
      line-height: 34px;
      display: flex;

      p {
        font-size: 16px;
        font-family: ArialMT;
        color: #353840;
        line-height: 40px;
        margin-left: 5px;
      }

      span {
        font-size: 14px;
        font-family: ArialMT;
        color: #8A949C;
        line-height: 40px;
        margin-left: 10px;
      }
    }

    .buy_btn {
      width: 40%;

      img {
        padding-right: 10px;
        padding-bottom: 5px;
      }
    }

    .tab_btn {
      font-size: 12px;
      font-family: ArialMT;
      color: #2181E2 !important;
      line-height: 14px;
    }
  }
}

.right_box {
  display: flex;
  justify-content: space-between;

  .yuan {
    width: 13px;
    height: 13px;
    background: linear-gradient(180deg, #55AA93 0%, #00674B 100%);
    border-radius: 50%;
    margin-right: 10px;
    margin-top:6px;
  }

  h3 {
    font-size: 24px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #161616;
    line-height: 28px;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  p {
    font-size: 14px;
    font-family: ArialMT;
    color: #8A949C;
    line-height: 25px;
  }

  span {
    font-size: 14px;
    font-family: ArialMT;
    color: #2181E2;
    line-height: 25px;
    margin-left: 5px;
    cursor: pointer
  }
}

::v-deep .top_btn_box {
  .el-button {
    padding-left: 30px;
    padding-right: 30px;
    font-size: 12px;
    font-family: Arial-BoldMT, Arial;
    font-weight: normal;
  }

  .bg_btn {
    border: 1px solid #2181E2;
    color: #2181E2;
  }
}

::v-deep .bg_btn_box {
  padding-left: 40px;
  padding-right: 40px;
  border: 1px solid #2181E2;
  color: #2181E2;
  font-size: 12px;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  margin-top: 18px;
}
.dialog_box_p{
  font-size: 24px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #161616 !important;
  margin-bottom:24px;
  margin-top:24px;
}
::v-deep .el-tag{
  height: 24px;
  line-height: 20px;
  padding:0 20px;
  font-size:14px;
  margin-top:10px;
  margin-bottom:30px;
}
::v-deep .el-tag.el-tag--success{
  background-color:rgba(30,188,118,0.1);
  color:#00B464;
}
::v-deep .el-tag.el-tag--danger{
  background-color:rgba(245,108,108,0.1);
  color:#F56C6C;
}
::v-deep .dia_sele_box{
  margin:0 auto;
  input[type="text"], select, textarea{
    background: #FFFFFF !important;
    border-right: none;
  }
  .el-form-item__label{
    font-size: 14px;
    font-family: ArialMT;
    color: #A6B0BE;
  }
  .el-form-item__label:first{
    margin-left:16%;
  }
  // .el-select .el-input {
  //   width: 100px;
  // }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
}

@media (min-width: 1400px) {
  .ban_box {
    width: 1280px;
  }
  .btm_box{
    width: 1280px;
  }
}
@media (max-width: 980px) {
  .banner_box {
    flex-wrap: wrap;
    .first_flex{
      flex: 0 0 100%;
      max-width: 100%;
    }
    .two_flex{
      flex: 0 0 100%;
      max-width: 100%;
      margin-left: 0;
    }
  }
}

</style>
